import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/catalogos/costos-de-plazas';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getPlazaCostos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET PlazaCosto
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPlazaCosto = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST PlazaCosto
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPlazaCosto = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH PlazaCosto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPlazaCosto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE PlazaCosto
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePlazaCosto = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR jornadaDetalle
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPlazaCosto = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Sincronizar Percepciones desde el catálogo a PlazaCosto
 * @param {number} plazaId El ID de la plaza a sincronizar
 * @returns {Promise<object|boolean>}
 */
export const sincronizarPercepcionesDePlaza = async (plazaId) => {
  try {
    // Nota: Esta URL es diferente al baseURI, es una acción sobre 'plazas'
    const response = await API.post(
      `/catalogos/plaza/${plazaId}/sincronizar-percepciones/`,
    );
    onSuccess(response, 'Percepciones sincronizadas correctamente');
    return response.data; // O 'true' si tu backend no devuelve datos
  } catch (err) {
    onError(err);
    return false;
  }
};
